import TextArea from "antd/es/input/TextArea";

function TextAreaComp({
  placeholder,
  showCount = false,
  label,
  id,
  onChange,
  value,
  maxValue,
}) {
  return (
    <div className="input-comp textarea-comp">
      <label className="input-label" htmlFor={id}>
        {label}
      </label>
      <TextArea
        autoSize={{
          minRows: 2,
          maxRows: 5,
        }}
        showCount={showCount}
        value={value}
        onChange={onChange}
        id={id}
        placeholder={placeholder}
        maxLength={maxValue}
      />
    </div>
  );
}

export default TextAreaComp;
